<template>
  <section :class='{topicals: true, phone: size == "phone"}'>
    <vue-horizontal class='row' v-for='(sets, index) in features' :key='index'>
        <div class='block' v-for="(column,index) in sets.columns"  :key="index">
          <template v-for='block in column.blocks'>
            <heading v-if='block.type == "heading"'
                class='heading'
                :key="block.id"
                :level='block.content.level'
                :text='block.content.text' />
            <buttonBlock v-if='block.type=="button"' :block='block' />
            <figure v-if='block.type == "image"'>
              <a :is='block.content.link ? "a" : "span"' :href='block.content.link ? block.content.link : false'>
                <img v-if='fileByUuid(page.files, block.content.image[0])' :src='fileByUuid(page.files, block.content.image[0]).src'>
              </a>
            </figure>
            <summary v-if='block.type == "text"'
                     v-html='block.content.text' />
          </template>
        </div>
    </vue-horizontal>
  </section>
</template>

<script>
import VueHorizontal from "vue-horizontal";
import mixins from './.././mixins.js';

export default {
  components: {VueHorizontal},
  props: ['features', 'page'],
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style>
  section.topicals {
    background-color: var(--lightmint);
    max-width: var(--main-max-width);
    margin: auto;
    box-sizing: border-box;
    padding: var(--main-padding);
    position: relative;
    z-index: 10;
    margin-bottom: 3rem;
  }

  section.topicals div.row {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  section.topicals:not(.phone) .block {
    width: calc(33.3% - 1px);
    min-width: 20rem;
    text-align: center;
    margin: 0;
    padding: 1rem 2.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  section.topicals.phone .block {
    width: 100%;
    min-width: 20rem;
    text-align: center;
    margin: 0;
    padding: 1rem 4.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  section.topicals.phone {
    max-width: calc( 100% - 5rem );
    padding: 0;
    border-left: 1px solid var(--mint);
    border-right: 1px solid var(--mint);
  }


  section.topicals:not(.phone) .block + .block {
    border-left: 1px solid var(--blue);
  }

  section.topicals figure {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  section.topicals figure img {
    width: 100%;
    max-height: 15rem;
    object-fit: contain;
  }

  section.topicals *.heading {
    margin: 1em 0;
  }

  section.topicals h1.heading {
    margin: 1.5em 0;
  }

  section.topicals h2.heading {
    margin: 2em 0;
  }

</style>
